 <div id="dialog" >
    <kendo-dialog (close)="onTertiaryButtonClick()" >
        <kendo-dialog-titlebar class="kendo-dialog-titlebar-div">
            <div >
                 {{dialogTitle}}
            </div>
        </kendo-dialog-titlebar>
        <span class="kendo-dialog-text">  {{dialogTextLine1}}<br> <pre>{{dialogTextLine2}}</pre> </span>
        <div>
            <button id="btnPrimary" class="k-button cvt-primary cvt-kendobutton "  (click)="onPrimaryButtonClick()">{{primaryButtonText}}</button>
           <button id="btnCancel" class="k-button cvt-kendobutton-cancel"  (click)="onSecondaryButtonClick()" *ngIf="secondaryButtonPresent">{{secondaryButtonText}}</button>
         </div>

     </kendo-dialog>
</div>
